//
// SASDriveFile.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../media/MediaType";
import "./Connection";
import "../media/FileMetadata";
import "../media/FileItem";

var SASDriveFile = createModule("transport::SASDriveFile", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        reportId: 7,
        fileMeta: 1,
        removedFromServer: 2,
        serverFileItem: 1,
        connection: 1,
        uuid: 7,
        newerVersionAvailable: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default SASDriveFile;
